<script>
import { defineComponent, computed } from '@vue/composition-api';
import { useSellerManagement } from '../../composables/useSellerManagement';

export default defineComponent({
  setup(props, { root }) {
    const {
      toggleEditing, isEditing,
    } = useSellerManagement();
    const handleGoBack = () => {
      root.$store.dispatch('carregarPerfil', { user: root.$auth.user });
      toggleEditing();
      root.$router.push('/sellers');
    };
    const isNewSeller = computed(() => root.$route.params.id === 'new');
    return {
      handleGoBack,
      isEditing,
      toggleEditing,
      isNewSeller,
    };
  },
});
</script>

<template>
  <div class="edit-seller-header">
    <v-layout
      row
      wrap
      style="align-items: center"
    >
      <v-btn
        flat
        icon
        color="primary"
        @click="handleGoBack()"
      >
        <v-icon>
          $vuetify.icons.arrowLeftIcon
        </v-icon>
      </v-btn>
      <v-btn
        flat
        icon
        color="primary"
        class="text-capitalize"
        @click="handleGoBack()"
      >
        Voltar
      </v-btn>
    </v-layout>
    <v-layout
      row
      wrap
      justify-space-between
      align-center
    >
      <TitleChip title="Gestão de Usuários" />
      <v-btn
        v-if="!isNewSeller"
        color="#FFADDE"
        class="edit-seller-header__btn text-capitalize"
        :disabled="isEditing"
        @click="toggleEditing()"
      >
        <v-layout
          row
          wrap
          align-center
        >
          <v-icon
            small
            class="mr-2"
          >
            $vuetify.icons.editIcon
          </v-icon>
          Editar
        </v-layout>
      </v-btn>
    </v-layout>
  </div>
</template>

<style lang="scss" scoped>
  .edit-seller-header {
    &__btn {
      border-radius: 39px;
      -webkit-box-shadow: 0px !important;
      box-shadow: 0px !important
    }
  }
  ::v-deep .v-btn {
  border-bottom: 0px;
  color: #140C22 !important;
  opacity: 1 !important;
  -webkit-box-shadow: 0px !important;
  box-shadow: 0px !important;
}
::v-deep .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
    will-change: box-shadow;
    -webkit-box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12);
    box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12);
}
</style>
